import React, { useRef, useImperativeHandle } from 'react';
import { styled } from '@mui/material';
import omit from 'lodash-es/omit';
import clsx from 'clsx';
import { IconSearch, IconLoading } from '../../internal/icons';
import { getStyle, inputClasses, searchClasses } from './style';
import Input from './Input';
const SearchBase = React.forwardRef((props, ref) => {
    const { onSearch: customOnSearch, onChange: customOnChange, onKeyDown: customOnKeyDown, prefix, suffix, loading, inputRef, ...rest } = props;
    const internalInputRef = useRef(null);
    useImperativeHandle(inputRef, () => internalInputRef?.current, []);
    const onChange = (e) => {
        if (e?.target && e.type === 'click' && customOnSearch) {
            customOnSearch(e?.target?.value, e, {
                source: 'clear',
            });
        }
        if (customOnChange) {
            customOnChange(e);
        }
    };
    const onSearch = (e) => {
        if (customOnSearch) {
            customOnSearch(internalInputRef.current?.value, e, {
                source: 'input',
            });
        }
    };
    const onKeyDown = (e) => {
        customOnKeyDown?.(e);
        // istanbul ignore next
        if (!internalInputRef.current) {
            return;
        }
        // For those browsers that do not support `isComposing`
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-boolean-literal-compare
        if (e.key === 'Enter' && e.nativeEvent.isComposing === false) {
            onSearch(e);
        }
    };
    const renderPrefix = () => (React.createElement(React.Fragment, null,
        React.createElement(IconSearch, { "aria-hidden": true, className: clsx(searchClasses.searchIcon) }),
        prefix));
    const renderSuffix = () => (React.createElement(React.Fragment, null,
        loading && React.createElement(IconLoading, { className: clsx(inputClasses.loadingIcon) }),
        suffix));
    return (React.createElement(Input, { ...rest, onKeyDown: onKeyDown, prefix: renderPrefix(), onChange: onChange, suffix: renderSuffix(), className: clsx(rest.className, searchClasses.search), inputRef: internalInputRef, ref: ref, "aria-busy": loading }));
});
const StyledSearch = styled(SearchBase)((props) => {
    const { theme, disabled, readOnly, status, prefix, suffix, allowClear, size, } = props;
    const shouldRenderAffix = !!prefix || !!suffix || !!allowClear;
    return getStyle(theme, {
        disabled,
        readOnly,
        status,
        size,
        shouldRenderAffix,
    });
});
const RefInput = React.forwardRef((props, ref) => (React.createElement(StyledSearch, { ...props, ref: ref })));
//  The exposed components must support the use of ref.
const Search = React.forwardRef((props, ref) => {
    const internalProps = omit(props, ['style']);
    return React.createElement(RefInput, { ...internalProps, ref: ref });
});
export default Search;
